import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins, Emit } from "vue-property-decorator";
// SYSTEMONE
import BaseMixer from "../../BaseMixer";
import { IVendorDTO } from "@/store/models/vendor/vendorDTO";
let VendorUpsertComponent = /** @class */ (() => {
    var _a;
    let VendorUpsertComponent = class VendorUpsertComponent extends Mixins(BaseMixer) {
        checkAndSendSave() {
            this.validate("vendorObserver").then((res) => {
                if (res) {
                    return this.save();
                }
            });
        }
        save() { }
        cancel() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IVendorDTO !== "undefined" && IVendorDTO) === "function" ? _a : Object)
    ], VendorUpsertComponent.prototype, "model", void 0);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VendorUpsertComponent.prototype, "save", null);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VendorUpsertComponent.prototype, "cancel", null);
    VendorUpsertComponent = __decorate([
        Component
    ], VendorUpsertComponent);
    return VendorUpsertComponent;
})();
export default VendorUpsertComponent;
